import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../constants/ActionTypes";
import UrlService from "../../../services/UrlService";
import {
  setSearchParamsProductListAction,
  setSearchParamsProductOverviewAction,
  setSearchParamsManhattanAction,
} from "./actions";
import {
  removeEmptyKeysAndUpdateURLWithCombinedParams,
  filterOutParamsNotToClearAndUpdateURL
} from "../../../utilites/searchParams";
import { setFilteredProductsAction, setSearchedProductsAction } from "../product/productList/actions";
import { filterState, searchProducts } from "../../../selectors/filterState";

const searchParamsMiddleware: Middleware = (store: MiddlewareAPI) => (
  next: Dispatch
) => (action: AnyAction) => {
  next(action);
  const paramsFromURL = UrlService.getParamsFromUrlOnLoadPage();
  const originalProducts = store.getState().products.items;

  switch (action.type) {
  case ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.CREATE: {
    const productListParams = removeEmptyKeysAndUpdateURLWithCombinedParams(paramsFromURL, action.payload);
    next(setSearchParamsProductListAction(Object.assign({}, paramsFromURL, productListParams)));

    const products = structuredClone(originalProducts);
    next(setFilteredProductsAction(filterState(products)));
    break;
  }
  case ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.SEARCH: {
    const products = structuredClone(originalProducts);
    next(setSearchedProductsAction(searchProducts(products, action.payload)));
    break;
  }
  case ActionTypes.SEARCH_PARAMS.PRODUCT_LIST.CLEAR: {
    const productListParamsFiltered = filterOutParamsNotToClearAndUpdateURL(paramsFromURL);
    next(setSearchParamsProductListAction(Object.assign({}, productListParamsFiltered)));

    const products = structuredClone(originalProducts);
    next(setFilteredProductsAction(filterState(products)));
    break;
  }
  case ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.CREATE:
    const productOverviewParams = removeEmptyKeysAndUpdateURLWithCombinedParams(paramsFromURL, action.payload);
    next(setSearchParamsProductOverviewAction({ ...paramsFromURL, ...productOverviewParams }));
    break;
  case ActionTypes.SEARCH_PARAMS.PRODUCT_OVERVIEW.CLEAR:
    const productOverviewParamsFiltered = filterOutParamsNotToClearAndUpdateURL(paramsFromURL);
    next(setSearchParamsProductOverviewAction({ ...productOverviewParamsFiltered }));
    break;

  case ActionTypes.SEARCH_PARAMS.MANHATTAN.CREATE:
    const mnhParams = removeEmptyKeysAndUpdateURLWithCombinedParams(paramsFromURL, action.payload);
    next(setSearchParamsManhattanAction({ ...paramsFromURL, ...mnhParams }));
    break;
  case ActionTypes.SEARCH_PARAMS.MANHATTAN.CLEAR:
    const mnhParamsFiltered = filterOutParamsNotToClearAndUpdateURL(paramsFromURL);
    next(setSearchParamsManhattanAction({ ...mnhParamsFiltered }));
    break;
  }
};

export default searchParamsMiddleware;
